import styled from 'styled-components'
import { Steps } from 'antd'
import { greys, font, lineHeight } from 'assets/themes/theme-default'

const AntStepsStyled = styled(Steps)`
  .ant-steps-item-wait {
    .ant-steps-item-icon {
      background-color: ${greys.light4};
      border-color: ${greys.dark3};
      > .ant-steps-icon {
        color: ${greys.dark3};
      }
    }
    > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
      color: ${greys.dark3};
    }
    > .ant-steps-item-container > .ant-steps-item-tail:after {
      height: 2px;
      background-color: ${greys.dark3};
      }
    }
  }
  .ant-steps-item-process {
    .ant-steps-item-icon {
      background-color: ${props => props.theme.colors.color1.bg};
      border-color: ${props => props.theme.colors.color1.bg};
      > .ant-steps-icon {
        color: ${greys.light4};
      }
    }
    > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
      color: ${props => props.theme.colors.color1.bg};
    }
    > .ant-steps-item-container > .ant-steps-item-tail:after {
      height: 2px;
      background-color: ${greys.dark3};
      
      }
    }
    .ant-steps-item-title{
      font-size: ${font.size.xs};
      line-height:${lineHeight.base}
    }
  }
  .ant-steps-item-finish {
    cursor: pointer;
    .ant-steps-item-icon {
      background-color: ${props => props.theme.colors.color2.bg};
      border-color: ${greys.light4};
      > .ant-steps-icon {
        color: ${greys.light4};
      }
    }
    > .ant-steps-item-container {
      > .ant-steps-item-content > .ant-steps-item-title {
      color: ${props => props.theme.colors.color2.bg};
    }
    > .ant-steps-item-tail:after {
      height: 2px;
      background-color: ${props => props.theme.colors.color2.bg};
      }
    }
  }
`

export default AntStepsStyled
